import React from "react";
import { MonitorSmartphone } from "lucide-react";

export const OneDeviceNotice = ({ testId = "one-device-notice", className = "" }) => (
  <div className={`flex gap-3 rounded-xl border border-amber-500/50 bg-amber-500/10 p-4 text-sm ${className}`} role="note" data-testid={testId}>
    <MonitorSmartphone size={18} className="mt-0.5 shrink-0 text-amber-400" />
    <p className="text-foreground">
      <b>One device at a time.</b> Your course can only be active on one device at a time — you can't be on a laptop or tablet and a phone at the same time.
      To switch, log out and log in on the other device: all your progress is saved to your account, not the device, so you carry on exactly where you left off.
    </p>
  </div>
);
